import { BoxTitle, ItemBox, ItemWrapper, SearchFieldWrapper } from "../style/ConditionSearch.styled";

export default function SearchFieldView ({ selectedSalesChannels }) {
    return (
        <SearchFieldWrapper>
            <BoxTitle>선택 채널 : </BoxTitle>
            <ItemWrapper>
                {selectedSalesChannels?.map((r, idx) => {
                    return (
                        <ItemBox
                            key={'slaes-channel-idx' + idx}
                            className='item-box'
                        >
                            <span>{r ?? '미지정'}</span>
                        </ItemBox>
                    )
                })}
            </ItemWrapper>
        </SearchFieldWrapper>
    )
}